
import { VuexModule, Module, Mutation, Action } from 'vuex-module-decorators';
import Rib from '@/extend/classes/Rib';
import { storeSession } from '@/generated/stores';
import HubServices from "@/generated/hub/HubServices";
import ListData, { ListItem, ColumnConfig, ListConfig, ListFilter } from '@/extend/classes/ListData';
import { Alerts } from '@/framework/base/helpers/Alerts';

import { v4 as uuidv4 } from 'uuid';


@Module({ name: 'storeRib' })

export default class storeRib extends VuexModule {
  // States
  private reccords: Rib[] = [];
  private config : ColumnConfig[] = [];
  private idsLoading: number[] = [];
  private dataLoading = false;
  private dataLoaded = false;
  private dataRegistered = false;

  // Getters on states for asynchronous actions
  private get ribLoading (): boolean {
    return this.dataLoading;
  }
  private get ribRegistered (): boolean {
    return this.dataRegistered;
  }

  
  public get ribLoaded (): boolean {
    return this.dataLoaded;
  }

  public get createNewRib() {
    return (): Rib => { 
      return this.getRib(0, true);
    }
  }

  
  public get getRib () {
    return (id: number, canCreate = false): Rib => {
      if (id == 0 && !canCreate) {
        Alerts.debug("Id Rib can't be 0")
        return new Rib();
      }
      const res = this.reccords.find(c => c.id == id);
      if (res != undefined) {
        return res;
      } else {
        const copy = new Rib();
        if (id == 0) {
          if (this.reccords.length == 0) {
            copy.id = -1;
          } else {
            this.reccords.sort((a, b) => (a.id - b.id));
            copy.id = Math.min(-1, this.reccords[0].id - 1);
          }          copy.canDelete = true;          copy.canUpdate = true;
          copy.createId = uuidv4();
          this.reccords.push(copy);
        } else if (id > 0) {
          copy.id = id;
          this.reccords.push(copy);
          if (storeSession.httpCx != undefined && !this.idsLoading.includes(id)) {
            this.idsLoading.push(id);
            Rib.getForStore(id).then((data: ListData) => {
              const tmpCopy = this.reccords.find(a => a.id == id);
              if (tmpCopy) {
                tmpCopy.fromRib(data.reccords[0] as Rib);
              }
              const config = data.config as ListConfig
              if (this.config.length == 0) {
                config.columnsConfig.forEach((column) => {
                  this.config.push(column);
                })
              } else {
                config.columnsConfig.forEach((column) => {
                  if (column.choix.length == 1) {
                    const columnConfig = this.config.find(a => a.name == column.name);
                    if (columnConfig && !columnConfig.choix.find(a => a.value == column.choix[0].value)) {
                      const columnChoix = columnConfig.choix;
                      const newChoix = column.choix[0];
                      columnChoix.push(newChoix);
                    }
                  }
                });
              }
              const index = this.idsLoading.findIndex(x => x == id);
              if (index >= 0) {
                this.idsLoading.splice(index, 1);
              }
            })
          }
        }
        return copy
      }
    }
  }


  

  public get listRib (): Rib[] {
    return this.reccords;
  }

  public get listConfigRib (): ColumnConfig[] {
    return this.config;
  }


  @Mutation
  private mRibRegistered (): void {
    this.dataRegistered = true;
  }

  @Mutation
  public mRibClearData (): void {
    this.reccords = [];
    this.idsLoading = [];
    this.dataLoading = false;
    this.dataLoaded = false;
    this.dataRegistered = false;
  }

  @Mutation
  private mRibLoading (value: boolean): void {
    this.dataLoading = value;
  }

  @Mutation
  private mRibLoaded (data: ListData): void {
    this.dataLoaded = true;
    this.idsLoading.splice(0, this.idsLoading.length);
    this.reccords = [];
    data.reccords.forEach((reccord) => {
      this.reccords.push(Rib.fromJson(reccord as Rib));
    })
    Rib.getDate(this.reccords);
    this.config = data.config.columnsConfig;
  }

  @Mutation
  private mRibConfigUpdated (newConfig: ListConfig): void {
    newConfig.columnsConfig.forEach((column) => {
      if (column.choix.length == 1) {
        const columnConfig = this.config.find(a => a.name == column.name);
        if (columnConfig && !columnConfig.choix.find(a => a.value == column.choix[0].value)) {
          const columnChoix = columnConfig.choix;
          const newChoix = column.choix[0];
          columnChoix.push(newChoix);
          console.log(newChoix);
        }
      }
    });
  }

  @Mutation
  public mRibCreated (obj: Rib): void {
    const index = this.idsLoading.findIndex(x => x == obj.id);
    if (index < 0) {
      let api = this.reccords.find(x => x.id == obj.id);
      if (api) {
        if (!api.compareRib(obj)) {
          api.fromRib(obj);
        }
      } else {
        api = this.reccords.find(x => x.createId == obj.createId && obj.createId != null && obj.createId != '');
        if (api) {
          if (!api.compareRib(obj)) {
            api.fromRib(obj);
          } else if (api.id != obj.id ) {
            api.id = obj.id;
          }
        } else {
          this.reccords.push(obj);
        }
      }
    }
  }

  @Mutation
  public mRibUpdated (obj: Rib): void {
    const index = this.idsLoading.findIndex(x => x == obj.id);
    if (index < 0) {
      const api = this.reccords.find(x => x.id == obj.id);
      if (api) {
        if (!api.compareRib(obj)) {
          api.fromRib(obj);
        }
      } else {
        this.reccords.push(obj);
      }
    }
  }

  @Mutation
  public mRibDeleted (id: number): void {
    const index = this.reccords.findIndex(x => x.id == id);
    if (index >= 0) {
      this.reccords.splice(index, 1);
    }
  }

    
  @Action
  public registerRib (filter: ListFilter | null = null): Promise<boolean> {
    return new Promise((resolve) => {
      if (!this.ribRegistered && storeSession.hubUsed) {
        if (HubServices.hubReady()) {
          HubServices.registerRib(this.ribCreated, this.ribUpdated, this.ribDeleted);
          this.mRibRegistered();
        } else {
          setTimeout(() => resolve(this.registerRib(filter)), 1000);
        }
      }
      if (filter != null) {
        if (HubServices.hubReady() && !this.ribLoading && !this.ribLoaded) {
          this.mRibLoading(true);
          return Rib.list(filter)
            .then((data: ListData) => {
              this.mRibLoaded(data);
              this.mRibLoading(false);
              resolve(true);
            })
        }
      } else  {
        resolve(true);
      }
  })
}


  @Action
  public listFilteredRib (filter: ListFilter): Promise<boolean> {
    return new Promise((resolve) => {
      if (HubServices.hubReady() && !this.ribLoading) {
        this.mRibLoading(true);
        return Rib.list(filter)
          .then((data: ListData) => {
            this.mRibLoaded(data);
            this.mRibLoading(false);
            resolve(true);
          })
      }
    })
  }


  
  @Action
  public createRib (obj: Rib): Promise<Rib> {
    return new Promise((resolve, reject) => {
      return Rib.fromJson(obj).createForStoreRib()
        .then((reccords) => {
          this.mRibCreated(reccords);
          resolve(reccords);
        })
        .catch(() => {
          reject();
        });
    })
  }

  
  @Action
  public updateRib (obj: Rib): Promise<Rib> {
    return new Promise((resolve, reject) => {
      return Rib.fromJson(obj).updateForStoreRib()
        .then((reccords) => {
          this.mRibUpdated(reccords);
          resolve(reccords);
        })
        .catch(() => {
          reject();
        });
    })
  }
  
  @Action
  public deleteRib (obj: Rib): Promise<boolean> {
    return new Promise((resolve, reject) => {
      return Rib.fromJson(obj).deleteForStoreRib()
        .then(() => {
          if (!storeSession.hubUsed) {
            this.mRibDeleted(obj.id);
          }
          resolve(true);
        })
        .catch(() => {
          reject();
        });
    })
  }

  
  @Action
  private ribCreated (objConfig: ListItem): void {
    const config = objConfig.config as ListConfig
    this.mRibConfigUpdated(config)
    const obj = objConfig.obj as Rib;
    this.mRibCreated(Rib.fromJson(obj));
  }

  @Action
  private ribUpdated (objConfig: ListItem): void {
    const config = objConfig.config as ListConfig
    this.mRibConfigUpdated(config)
    const obj = objConfig.obj as Rib;
    this.mRibUpdated(Rib.fromJson(obj));
  }

  @Action
  private ribDeleted (objConfig: ListItem): void {
    const obj = objConfig.obj as Rib;
    this.mRibDeleted(obj.id);
  }
}
